import { Icon, IconText, bulma } from "trunx";
import {
  IconDefinition,
  faBookmark,
  faCloudRain,
  faLayerGroup,
  faMapPin,
  faTape,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPanel } from "./models/Menus";
import { LangSelect } from "./shared/LangSelect";
import config from "./config";
import { useLocaleContext } from "./contexts/LocaleContext";
import { useRootStore } from "./models/Root";

interface NavMenuItemProps {
  panel: IPanel;
  icon: IconDefinition;
}
const NavMenuItem = ({ panel, icon }: NavMenuItemProps) => {
  const {
    dict: { panel: panelDict },
  } = useLocaleContext();
  const { title } = panelDict[panel];

  const {
    menus: { openPanel },
} = useRootStore();

  return (
    <li>
      <IconText onClick={() => openPanel(panel)}>
        <Icon>
          <FontAwesomeIcon icon={icon} />
        </Icon>
        <span>{title}</span>
      </IconText>
    </li>
  );
};

const NavMenu = () => {
  const {
    dict: {
      panel: { display, tools },
    },
  } = useLocaleContext();

  const { layers } = useRootStore();
  const { radar } = config;

  return (
    <aside className={bulma("menu")}>
      <p className={bulma("menu-label")}>{display}</p>
      <ul className={bulma("menu-list")}>
        {layers.any && <NavMenuItem panel="layers" icon={faLayerGroup} />}
        <NavMenuItem panel="sensors" icon={faMapPin} />
        {radar && <NavMenuItem panel="radar" icon={faCloudRain} />}
      </ul>
      <p className={bulma("menu-label")}>{tools}</p>
      <ul className={bulma("menu-list")}>
        <NavMenuItem panel="bookmarks" icon={faBookmark} />
        <NavMenuItem panel="measure" icon={faTape} />
      </ul>
      <p className={bulma("menu-label")}>&nbsp;</p>
      <ul className={bulma("menu-list")}>
        <LangSelect />
      </ul>
    </aside>
  );
};
export default NavMenu;
